import React from 'react';
import './index.css';

export default function MovingGradients() {
  return (
    <div className="moving-gradients-container">
      <div className="gradient-blob gradient-blob-1"></div>
      <div className="gradient-blob gradient-blob-2"></div>
      <div className="gradient-blob gradient-blob-3"></div>
      <div className="gradient-blob gradient-blob-4"></div>
    </div>
  );
}

 